export default "__VITE_ASSET__C78EqklV__"